import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { Lang, LanguageService } from '../../core/language.service';
import { environment } from '../../../environments/environment';

interface MenuItem {
  labelKey: string;
  link: string;
  ready: boolean;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy {
  // Acceso a la aplicación de gestión (login externo).
  readonly loginUrl = environment.intraWebUrl;

  // Estado del menú hamburguesa en móvil/tablet.
  menuOpen = false;

  // Rollout progresivo: cada página se activa (ready: true) al desarrollarse y validarse.
  readonly menu: MenuItem[] = [
    { labelKey: 'nav.home', link: '/', ready: true },
    { labelKey: 'nav.about', link: '/quienes-somos', ready: true },
    { labelKey: 'nav.system', link: '/sistema-gesvatec', ready: true },
    { labelKey: 'nav.label', link: '/etiqueta', ready: true },
    { labelKey: 'nav.certificate', link: '/certificado', ready: true },
    { labelKey: 'nav.products', link: '/productos-gestionados', ready: true },
    { labelKey: 'nav.clients', link: '/clientes', ready: true },
    { labelKey: 'nav.support', link: '/soporte', ready: true },
    { labelKey: 'nav.contact', link: '/contacto', ready: true },
  ];

  private readonly navSub: Subscription;

  constructor(private readonly language: LanguageService, router: Router) {
    // Cierra el menú hamburguesa al navegar entre páginas.
    this.navSub = router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => (this.menuOpen = false));
  }

  get current(): Lang {
    return this.language.current;
  }

  setLang(lang: Lang): void {
    this.language.use(lang);
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  ngOnDestroy(): void {
    this.navSub.unsubscribe();
  }
}
